import React from 'react';
import { Route, Routes } from 'react-router';
import { routes } from '../routes/routes-names';
import Dashboard from '../dashboard';
import Layout from '../layout';
import UserManagement from '../user-management';
import ReportedCompanies from '../company-list-old';
import CompanyList from '../company-list';
import CompanyView from '../company-list-old/company-view';
import CandidateList from '../candidate-list';
import ReportedCandidateList from '../candidate-list-old';
import CandidateView from '../candidate-list/candidate-view';
import CompanyVerification from '../company-verification';
import Policy from '../../containers/policy/policy';
import CompanyRegistration from '../company-registrations/companyRegister';
import CompanyRegistrationLanding from '../company-registrations/companyRegistrationLanding';
import CompanyVerificationLanding from '../company-verification/companyVerificationLanding';
import CandidateListLanding from '../candidate-list/candidateListLanding';
import CompanyListLanding from '../company-list/companyListLanding';
import HRMSCompanyListLanding from '../hrms-company-list/hrmsCompanyListLanding';
import AffiliatedUsers from '../affiliated-marketing/users';
import AffiliatedCompanies from '../affiliated-marketing/companies';
import CandidateInviteLanding from '../candidate-invitations/candidateInviteLanding';
import RewardsTable from '../../components/rewards';
import CompleteListLanding from '../match-list/complete-match/completeListLanding';
import NomatchListLanding from '../match-list/no-match/nomatchListLanding';
import MostLikelyMatchTable from '../match-list/most-likely/mostLikelyMatchTable';
import LessLikelyMatchTable from '../match-list/less-likely/lessLikelyMatchTable';
import ReportManagement from '../report-management';
import PartnerReportManagement from '../partner-report-management/PartnerReportManagement';

const Room = () => {
    return (
        <Layout>
            <Routes>
                <Route path={routes.dashboard} element={<Dashboard />} />
                <Route path={routes.reportedCompanyList} element={<ReportedCompanies />} />
                <Route path={routes.companyRegistration} element={<CompanyRegistrationLanding />} />
                <Route path={routes.companyVerification} element={<CompanyVerificationLanding />} />
                <Route path={routes.companyList} element={<CompanyListLanding />} />
                <Route path={routes.companyRewardsList} element={<RewardsTable />} />
                <Route path={routes.hrmsCompanyList} element={<HRMSCompanyListLanding />} />
                <Route path={routes.candidateList} element={<CandidateListLanding />} />
                <Route path={routes.completeMatch} element={<CompleteListLanding />} />
                <Route path={routes.mostLikelyMatch} element={<MostLikelyMatchTable />} />
                <Route path={routes.lessLikelyMatch} element={<LessLikelyMatchTable />} />
                <Route path={routes.noMatch} element={<NomatchListLanding />} />
                <Route path={routes.candidateInvite} element={<CandidateInviteLanding />} />
                <Route path={routes.reportedCandidateList} element={<ReportedCandidateList />} />
                <Route path={routes.userManagement} element={<UserManagement />} />
                <Route path={routes.CompanyView} element={<CompanyView />} />
                <Route path={routes.candidateView} element={<CandidateView />} />
                <Route path={routes.policy} element={<Policy />} />
                <Route path={routes.affiliateUser} element={<AffiliatedUsers />} />
                <Route path={routes.affiliateCompanies} element={<AffiliatedCompanies />} />
                <Route path={routes.reportManagement} element={<ReportManagement />} />
                <Route path={routes.partnerReportManagement} element={<PartnerReportManagement />} />
            </Routes>
        </Layout>
    );
};

export default Room;
